import { useContext } from 'react'

import { ModalContext, SidebarModal } from '@domain-group/suit-theme'

import { useSetState } from '@domain-group/react-hooks'

import type { HandleCallbackActionParams } from '@domain-group/javascript-utils'

import DefaultState from './screens/DefaultState'
import ExistingCampaign from './screens/ExistingCampaign'
import NewCampaign from './screens/NewCampaign'

const MODAL_KEY = 'CreateAgencyMarketingCampaignModal'

const modalTitles = {
  NewCampaign: {
    title: 'Create',
    subtitle: 'New Campaign',
  },
  ExistingCampaign: {
    title: 'Add to',
    subtitle: 'Existing Campaign',
  },
}

type DefaultStateParams = {
  selectedScreen: null | 'NewCampaign' | 'ExistingCampaign',
}

const defaultState: DefaultStateParams = {
  selectedScreen: null,
}

type ModalCallbacks = {
  closeModal: () => void,
  createArtworkForExistingCampaign: (payload: HandleCallbackActionParams) => void,
  createCampaignAndArtwork: (payload: HandleCallbackActionParams) => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const CreateAgencyMarketingCampaignModal = (props: ModalProps) => {
  const { callbacks, showModal } = props

  const [state, setState] = useSetState(defaultState)
  const { selectedScreen } = state

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = modalData?.[MODAL_KEY] ?? {}
  const { agencyMarketingCampaignParams } = modalPayload
  const { createCampaignWithArtwork = true, hideComponents = [] } = agencyMarketingCampaignParams

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header
        callbacks={callbacks}
        title={selectedScreen ? modalTitles[selectedScreen].title : 'New Agency'}
        titleSecondLine={selectedScreen ? modalTitles[selectedScreen].subtitle : 'Marketing'}
      />

      {!selectedScreen && (
        <DefaultState
          callbacks={{ selectScreen: screen => setState({ selectedScreen: screen }) }}
          hideComponents={hideComponents}
        />
      )}

      {selectedScreen === 'ExistingCampaign' && (
        <ExistingCampaign
          agencyMarketingCampaignParams={agencyMarketingCampaignParams}
          // @ts-expect-error TS2741
          callbacks={callbacks}
        />
      )}

      {selectedScreen === 'NewCampaign' && (
        <NewCampaign
          agencyMarketingCampaignParams={agencyMarketingCampaignParams}
          // @ts-expect-error TS2741
          callbacks={callbacks}
          createCampaignWithArtwork={createCampaignWithArtwork}
        />
      )}
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <CreateAgencyMarketingCampaignModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
